import { Link } from "react-router-dom";
import {
  NODES,
  NODE_LINKS,
  SNIPPETS,
} from "@/app/features/diagrams/functions/heroSystem/constants";

export type SnippetCardProps = {
  activeNode: string;
};

export function SnippetCard({ activeNode }: SnippetCardProps) {
  const getFormattedSnippet = (nodeId: string) => {
    const raw = SNIPPETS[nodeId] || SNIPPETS.default || "";
    const colonIndex = raw.indexOf(":");
    if (colonIndex !== -1) {
      const prefix = raw.slice(0, colonIndex + 1);
      const body = raw.slice(colonIndex + 1);
      return (
        <>
          <span className="font-[650] text-ga-signal transition-colors duration-300 mr-1.5">
            {prefix}
          </span>
          <span className="text-ga-text-muted group-hover/link:text-ga-ink transition-colors duration-300">
            {body}
          </span>
        </>
      );
    }
    return (
      <span className="text-ga-text-muted group-hover/link:text-ga-ink transition-colors duration-300">
        {raw}
      </span>
    );
  };

  const getLabelType = (nodeId: string) => {
    if (nodeId === "center") return "Overview";
    const node = NODES.find((n) => n.id === nodeId);
    if (!node) return "Overview";
    return node.type === "capability" ? "Capability" : "Industry Focus";
  };

  return (
    <Link
      to={NODE_LINKS[activeNode] || "/about"}
      className="group/link block mt-auto px-6 py-5 border-t border-ga-line shrink-0 h-[7.8rem] md:h-[6.8rem] code flex-col justify-center transition-all duration-300 bg-black/2 dark:bg-white/2 hover:bg-ga-highlight/5 hover:border-t-ga-highlight/30 focus-visible:bg-ga-highlight/5 focus-visible:border-t-ga-highlight/30 outline-none rounded-b-shell translate-z-[15px]"
    >
      <div className="w-full text-left">
        <span className="block text-[0.55rem] md:text-[0.58rem] font-[750] uppercase tracking-widest text-ga-signal group-hover/link:text-ga-signal transition-colors duration-200 mb-1">
          {getLabelType(activeNode)}
        </span>
        <p className="text-[0.75rem] md:text-[0.8rem] font-mono leading-relaxed">
          {getFormattedSnippet(activeNode)}
        </p>
      </div>
    </Link>
  );
}
